import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Avatar from "@mui/material/Avatar";
import Icon from "@mui/material/Icon";
import { Box } from "@mui/material";

class ButtonCard extends React.Component {
    constructor() {
        super();
        this.click = this.click.bind(this);
    }
    
    click() {
        if (this.props.pathname.startsWith("http")) {
            window.open(this.props.pathname, "_blank");
        } else {
            this.props.history.push({ pathname: this.props.pathname });
        }
    }

    render() {
        return (
            <Card className={`maintenance-card ${this.props.className || ''}`}>
                    <CardHeader
                        title={this.props.title}
                        subheader={this.props.subTitle}
                        avatar={<Avatar><Icon>{this.props.icon}</Icon></Avatar>}
                    />
                    <Box className="maintenance-card-actions">
                        <Button onClick={this.click}>{this.props.actionName}</Button>
                    </Box>
                </Card>
        );
    }
}

ButtonCard.propTypes = {
    actionName: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string,
    className: PropTypes.string,
    history: PropTypes.object.isRequired,
    pathname: PropTypes.string.isRequired,
};

export default ButtonCard;